// extracted by mini-css-extract-plugin
export default {"root":"ItemsGrid_root__vFDrJ","container":"ItemsGrid_container__oTAQ9","cell":"ItemsGrid_cell__SegaS"};